import React, { useEffect, useState } from "react";
import "./Hero.css";
import IMAGES from "../../images/LandingPage";
import axios from "axios";
import SwitchAccessShortcutAddSharpIcon from "@mui/icons-material/SwitchAccessShortcutAddSharp";
import StarPurple500SharpIcon from "@mui/icons-material/StarPurple500Sharp";
import TrySharpIcon from "@mui/icons-material/TrySharp";
import HikingSharpIcon from "@mui/icons-material/HikingSharp";
import ModeOfTravelSharpIcon from "@mui/icons-material/ModeOfTravelSharp";
import BusinessCenterSharpIcon from "@mui/icons-material/BusinessCenterSharp";
import ArrowOutwardSharpIcon from "@mui/icons-material/ArrowOutwardSharp";
import { useNavigate } from "react-router-dom";
import Typewriter from "typewriter-effect";

const Hero = () => {
  const navigate = useNavigate();
  const [trip, setTrip] = useState(null);
  const [search, setSearch] = useState(null);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    if (e.target.value === "") {
      setSearch(null);
    }
  };

  const searchTrip = trip?.filter((obj) =>
    obj.heading.toLowerCase().includes(search?.toLowerCase())
  );

  const getAllTrips = async () => {
    const res = await axios.get("api/trips/get-all-trips");
    if (res.data.success) {
      setTrip(res.data.data);
    }
  };

  useEffect(() => {
    getAllTrips();
  }, []);

  // ✨ Reviews data (image + text + name)
  const reviews = [
    {
      img: IMAGES.rev1,
      text: "From Ladakh to Bali, Nepal to Thailand, and even Dubai -every trip with High Mountains felt like a new adventure . Aman and his team made travel feel effortless, fun, and unforgetable!",
      name: "Nitish",
    },
    {
      img: IMAGES.rev2,
      text: "Bali was magical and Ladakh was pure thril! The High Mountains team handled everything so smoothly -adventure, luxury, and the right people to share it with.",
      name: "Sandeep",
    },
    {
      img: IMAGES.rev3,
      text: "Winter in Kashmir and Ladakh was surreal! Snow drives ,frozen lakes, and that warm High Mountains vibe made me fall in love with Himalayas all over again.",
      name: "Anirban",
    },
    {
      img: IMAGES.rev4,
      text: "Bali parties, Massai Mara sunsets, and Tanzania safaris - I've travelled the world with Aman and team! No one does group trips better than High Mountains.",
      name: "Goldy",
    },
    {
      img: IMAGES.rev5,
      text: "As a solo traveller, I've explored Thailand, Ladakh, and even Tanzania with High Mountains.Safe, social, and full of crazy memories - best travel tribe ever !",
      name: "Sonu Patel",
    },
    {
      img: IMAGES.rev6,
      text: "Kenya and Tanzania were beyond imagination! The ASG Batches delivered wildlife,culture, and adventure in one go- couldn't have asked for a better African journey.",
      name: "Achin",
    },
    {
    img: IMAGES.rev7,
    text: "From Ladakh summers to Kargil’s Apricot Blossom, every trip with High Mountains feels personal. Kiran and team make solo travel safe and soulful.",
    name: "Niharika ",
  },
  {
    img: IMAGES.rev8,
    text: "I’ve done Ladakh in every season — summer, winter, and the Apricot Blossom — plus Kashmir with Aman! Every journey feels like home with this team.",
    name: "Khushi ",
  },
  {
    img: IMAGES.rev9,
    text: "Our Ladakh, Himachal, and Nepal trips with High Mountains were seamless. From romance to adventure, Aman and team planned everything beautifully.",
    name: "Shiv & Priyanka",
  },
  {
    img: IMAGES.rev10,
    text: "Summer in Ladakh, winter in the Himalayas, and beach life in Bali — all thanks to High Mountains! Pure vibes, zero stress, and full value for every moment.",
    name: "Rajat",
  },
  {
    img: IMAGES.rev11,
    text: "Ladakh’s mountains and Bali’s beaches — two extremes, one emotion. High Mountains made both adventures smooth, safe, and full of love.",
    name: "Girish & Tapasya ",
  },
  {
    img: IMAGES.rev12,
    text: "From Dubai rooftops to Bali beaches and Ladakh’s high passes — every trip was next-level! The Igloo Stay in Himachal was the icing on the cake.",
    name: "Karan",
  },
  {
    img: IMAGES.rev13,
    text: "Ladakh’s rugged charm and Bali’s tropical bliss — I’ve done both with ASG Batches! High Mountains knows how to balance thrill and chill perfectly.",
    name: "Pratik",
  },
  {
    img: IMAGES.rev14,
    text: "Whether it’s Himachal treks or Thailand parties, Aman and team make every moment count. Bali and Ladakh with High Mountains were absolute perfection.",
    name: "Sarfaraz",
  },
  {
    img: IMAGES.rev15,
    text: "From riding snow bikes in Ladakh to staying in Igloos and flying to Dubai — every trip with High Mountains feels safe, exciting, and empowering.",
    name: "Krishna",
  },
  {
    img: IMAGES.rev16,
    text: "Bali’s floating breakfast, Himachal’s snow, and Ladakh’s landscapes — I’ve done it all with High Mountains! Every trip is a vibe.",
    name: "Shivangi",
  },
  {
    img: IMAGES.rev17,
    text: "Sri Lanka beaches, Ladakh roads, and Thailand nights — High Mountains truly covers it all! The perfect balance of peace and party.",
    name: "Mohana",
  },
  {
    img: IMAGES.rev18,
    text: "From Ibiza’s beaches to Maasai Mara safaris, and Ladakh’s passes — every journey with Aman Singh Gulati felt luxurious, wild, and full of soul.",
    name: "Sanya",
  },
  {
    img: IMAGES.rev19,
    text: "Rode across Ladakh with High Mountains — what a rush! The crew ensured safety, adventure, and sisterhood on every turn.",
    name: "Sony Chanchalani",
  },
  {
    img: IMAGES.rev20,
    text: "Ladakh and Nepal back-to-back with ASG — absolutely flawless! The team’s energy and organization make even the toughest terrains easy.",
    name: "Gagan",
  },
  {
    img: IMAGES.rev21,
    text: "Our Ladakh road trip with High Mountains was a dream come true! Scenic stays, great company, and perfect planning by Aman’s crew.",
    name: "Apekshit & Sanika ",
  },
  {
    img: IMAGES.rev22, 
    text: "Did Ladakh solo on my bike with ASG support — never felt alone for a second! The on-ground assistance and vibe were unbeatable",
    name: "Dhruv  ",
  },
  {
    img: IMAGES.rev23,
     text: "Travelling solo with High Mountains was the best decision ever! From Ladakh to Bali, Aman’s team made every trip feel safe, spontaneous, and full of real connections — no awkward moments, just pure good vibes.",
    name: "Varsha  ",
  },
   {
    img: IMAGES.rev24, 
    text: "From the calm mountains of Ladakh to the pine trails of Himachal and beaches of Goa — every trip with High Mountains felt safe, vibrant, and full of energy. Aman’s team knows exactly how to make solo travel feel fearless and fun!",
    name: "Charu  ",
  },
  ];

  return (
    <div className="hero-container Mon_font">
      <div className="hero-bg">
        <div className="hero-bckd">
          {/* HERO CONTENT */}
          <div className="hero-content">
            <h1 className="m-0">
              Book Your{" "}
              <img className="ms-4 blob-img" src={IMAGES.herobanner} alt="" />
            </h1>
            <h1 className="m-0 d-flex">
              Trip to{" "}
              <span className="ffca00 ms-2">
                <Typewriter
                  options={{
                    autoStart: true,
                    loop: true,
                    delay: 50,
                    strings: [
                      "Manali",
                      "Ladakh",
                      "Spiti",
                      "Kashmir",
                      "Thailand",
                      "Vietnam",
                      "Bali",
                    ],
                  }}
                />
              </span>
            </h1>
            <div className="hero-text mt-5 text-white">
              <span className="fs-4">#UNFUCKTHEWORLD</span>
              <br />
              Navigate the World of Flavors at Our{" "}
              <span className="ffca00">Wanderlust Bar</span>, <br />
              Where Each Sip is a Ticket to a Different <br />
              <span className="ffca00">Corner of the Globe</span>.
              <br />
            </div>

            {/* SEARCH */}
            <div className="hero-search-container">
              <input
                type="text"
                className="hero-search-input"
                placeholder="Search Trips"
                onChange={handleSearch}
              />
              {search === null ? (
                ""
              ) : searchTrip?.length === 0 ? (
                <div className="search-box-empty">No Result Found</div>
              ) : (
                <div className="search-box">
                  {searchTrip?.map((item, index) => (
                    <div
                      key={index}
                      className="search-items"
                      onClick={() =>
                        navigate(
                          `/trip/${item?.heading.replace(/\s+/g, "-")}`
                        )
                      }
                    >
                      <span>{item?.heading}</span>
                      <span>
                        <ArrowOutwardSharpIcon className="icon" />
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* REVIEW CONTENT */}
          <div className="hero-review-container">
            <div className="reviews-vertical">
              {[...reviews, ...reviews].map((r, idx) => (
                <div className="reviews" key={idx}>
                  <img src={r.img} alt={r.name} />
                 <div className="reviews-content">
  <div className="reviewer-header">
    <span className="reviewer-name ffca00">
      <b>{r.name}</b>
    </span>
    <div className="star">
      {[...Array(5)].map((_, i) => (
        <StarPurple500SharpIcon key={i} className="icon" />
      ))}
    </div>
  </div>

  <div className="review">
    <span>
      <small>{r.text}</small>
    </span>
  </div>
</div>


                </div>
              ))}
            </div>
          </div>

          {/* COUNTERS */}
          <div className="hero-counters">
            <div className="counter">
              <TrySharpIcon className="icon" />
              <div className="counter-content">
                <h4>
                  <b>2000+</b>
                </h4>
                <span>
                  <small>Reviews</small>
                </span>
              </div>
            </div>
            <div className="counter">
              <HikingSharpIcon className="icon" />
              <div className="counter-content">
                <h4>
                  <b>31,242+</b>
                </h4>
                <span>
                  <small>Happy Travelers</small>
                </span>
              </div>
            </div>
            <div className="counter">
              <ModeOfTravelSharpIcon className="icon" />
              <div className="counter-content">
                <h4>
                  <b>40+</b>
                </h4>
                <span>
                  <small>Destinations</small>
                </span>
              </div>
            </div>
            <div className="counter">
              <BusinessCenterSharpIcon className="icon" />
              <div className="counter-content">
                <h4>
                  <b>100+</b>
                </h4>
                <span>
                  <small>Experience</small>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
